export default "__VITE_ASSET__DnU_sz4k__"